import { useCallback, useEffect, useState } from "react";
import "@/App.css";
import axios from "axios";
import Lenis from "lenis";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { API } from "@/lib/site";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Mission } from "@/components/Mission";
import { Impact } from "@/components/Impact";
import { Programs } from "@/components/Programs";
import { Stories } from "@/components/Stories";
import { Donate } from "@/components/Donate";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function Landing() {
  const [campaign, setCampaign] = useState(null);

  const refreshCampaign = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/campaign`);
      setCampaign(data);
    } catch (e) {
      console.error("campaign stats unavailable", e);
    }
  }, []);

  useEffect(() => {
    refreshCampaign();
  }, [refreshCampaign]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-paper text-ink antialiased">
      <div className="grain" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero campaign={campaign} />
        <Marquee />
        <Mission />
        <Impact campaign={campaign} />
        <Programs />
        <Stories />
        <Donate />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
      </Routes>
      <Toaster richColors closeButton position="top-center" />
    </BrowserRouter>
  );
}

export default App;
